import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component({
    name: "ChoiceExam",
    components: {}
})
export default class ChoiceExam extends Vue {
    private choices: Array<string> = [];
    @Prop() private item: any;
    @Prop() private num: number;
    @Prop() private isAnsweringQuestion: boolean;
    @Prop() private isPass: boolean;

    @Emit()
    handlerChoiceClick(choiceIndex) {
        if (this.item.type === "radio") {
            this.choices = [];
            this.choices.push(choiceIndex);
        } else {
            if (this.choices.indexOf(choiceIndex) > -1) {
                this.choices.splice(this.choices.indexOf(choiceIndex), 1);
            } else {
                this.choices.push(choiceIndex);
            }
        }
        let endTime = new Date();
        return {
            num: this.num,
            answer: this.choices.sort().join(","),
            endTime: endTime
        };
    }
}

//@ts-ignore
export { default as ChoiceExam } from "./index.vue";
